import { render, staticRenderFns } from "./yancao.vue?vue&type=template&id=32b1cb89&scoped=true"
import script from "./yancao.vue?vue&type=script&lang=js"
export * from "./yancao.vue?vue&type=script&lang=js"
import style0 from "./yancao.vue?vue&type=style&index=0&id=32b1cb89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1cb89",
  null
  
)

export default component.exports